module.exports = __webpack_public_path__ + "img/lens-174-plus-03.1c9df8f4.png";